import {Component, OnChanges} from '@angular/core';
import * as _ from 'lodash';


import { LanguagePageMixin } from 'shared/language-page/language-page-mixin';
import { applyMixins } from 'utils/utils';

import { BaseSegmentComponent } from '../base/_base-segment.component';


@Component({
  moduleId: module.id,
  selector: 'description-segment',
  templateUrl: 'description.component.html',
  styleUrls: ['description.component.scss'],
})
class DescriptionComponent extends BaseSegmentComponent implements LanguagePageMixin, OnChanges {

  showMore: boolean = false;
  showMoreData: any = [];
  selectedLanguage: string = 'EN';
  languagesItems: any[] = [];

  getItemLanguages: (item: any) => string[];

  getLanguagePath: (item: any) => string;

  addLanguages: (data: any) => void;

  ngOnChanges() {
    this.data = this.orderBy(this.data);
    if (_.has(this, 'itemDetail.descriptions')) {
      const descriptions = _.values(this.itemDetail.descriptions);
      const languages = _.uniq(_.flatten(_.map(descriptions, (item) => _.keys(item))));
      this.addLanguages(languages);
    }
  }

  onLanguageChange(event: any) {
    this.selectedLanguage = event.code;
  }

  /*******************************************
   * COMPONENT PRIVATE METHODS
   *******************************************/

  private getBadgeVariation(item: any, language: any): string {
    // show badge danger if we have description error for this language
    if (this.hasError(item.item_name, language)) {
      return 'danger';
    }
    return 'default';
  }
}

applyMixins(DescriptionComponent, [LanguagePageMixin]);

export { DescriptionComponent };
